import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './paypal_logo.less'

class PayPalLogo extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['color', 'mono']),
    paypalDomain: PropTypes.string,
  }

  render() {
    const logoUrl = `https://${this.props.paypalDomain}/`
    return (
      <a styleName="paypal-logo-link" href={logoUrl} target="_blank">
        <div styleName={`paypal-logo-${this.props.type}`} />
      </a>
    )
  }
}

export default cssModules(PayPalLogo, styles)
